import ZoomedOutAvatar from './ZoomedOutAvatar';

export default ZoomedOutAvatar;
